"use client";

import { cn } from "@/lib/utils";
import type { MouseEventHandler, ReactNode } from "react";

export const Overlay = ({
  className,
  onClick,
  children,
}: {
  className?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  children?: ReactNode;
}) => {
  return (
    <div
      className={cn(
        // ヘッダーを抜いた高さ
        "absolute h-[calc(100svh-80px)] w-screen bg-black opacity-30",
        className,
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
